const DB_NAME = "pos-local-db";
const STORE_NAME = "fnb-settings";
const DB_VERSION = 2;
const WORKSTATION_KEY = "workstation";

export const WORKSTATION_UPDATED_EVENT = "workstation-updated";

let dbInstance = null;

function openDb() {
  return new Promise((resolve, reject) => {
    if (dbInstance) return resolve(dbInstance);

    if (!window.indexedDB) {
      reject(new Error("IndexedDB is not supported in this browser."));
      return;
    }

    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = event => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = event => {
      dbInstance = event.target.result;
      resolve(dbInstance);
    };

    request.onerror = () => reject(request.error);
  });
}

export async function getWorkstation() {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(WORKSTATION_KEY);

    request.onsuccess = event => resolve(event.target.result || "");
    request.onerror = () => reject(request.error);
  });
}

export async function saveWorkstation(workstation) {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    store.put(workstation, WORKSTATION_KEY);

    tx.oncomplete = () => {
      window.dispatchEvent(
        new CustomEvent(WORKSTATION_UPDATED_EVENT, {
          detail: workstation
        })
      );
      resolve(true);
    };
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}

export async function clearWorkstation() {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    store.delete(WORKSTATION_KEY);

    tx.oncomplete = () => {
      window.dispatchEvent(
        new CustomEvent(WORKSTATION_UPDATED_EVENT, {
          detail: ""
        })
      );
      resolve(true);
    };
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  });
}



// WEBPACK FOOTER //
// ./src/util/indexDb/workstationIndexDb.js